(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["carousel"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-carousel]').forEach((root) => {
  const track = root.querySelector('[data-carousel-track]');
  const prev = root.querySelector('[data-carousel-prev]');
  const next = root.querySelector('[data-carousel-next]');
  const count = track.children.length;
  const slidePct = parseFloat(root.dataset.carouselSlideWidth) || 100;
  let index = Math.min(
    Math.max((parseInt(root.dataset.carouselStart, 10) || 1) - 1, 0),
    count - 1
  );

  const update = (animate) => {
    const w = root.clientWidth;
    const slideW = (w * slidePct) / 100;
    // 表示中スライドを中央に置き、端では空白が出ないよう端寄せにクランプ
    const centered = (w - slideW) / 2 - index * slideW;
    const min = Math.min(w - slideW * count, 0);
    const x = Math.min(Math.max(centered, min), 0);
    track.style.transition = animate ? 'transform 0.5s ease' : 'none';
    track.style.transform = `translateX(${x}px)`;
    prev.disabled = index === 0;
    next.disabled = index === count - 1;
  };

  prev.addEventListener('click', () => {
    if (index > 0) {
      index -= 1;
      update(true);
    }
  });
  next.addEventListener('click', () => {
    if (index < count - 1) {
      index += 1;
      update(true);
    }
  });
  window.addEventListener('resize', () => update(false));
  update(false);
});
  } catch(e) { console.error(e); }
})();

})();
